import { HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { Auth, getIdToken } from "@angular/fire/auth";
import { from } from "rxjs";
import { switchMap } from "rxjs/operators";

export const authInterceptor: HttpInterceptorFn = (request, next) => {
    const auth = inject(Auth);

    if (!auth.currentUser) {
        return next(request);
    }

    return from(getIdToken(auth.currentUser)).pipe(
        switchMap((token) => {
            const headers = request.headers.set("id-token", token);
            const authenticatedRequest = request.clone({ headers });
            return next(authenticatedRequest);
        })
    );
};
